import cln from 'classnames';

import {
  Text,
  useZustandModalKitStore,
  zustandModalKitSelector,
  EModalTypes,
} from 'react-gldn-kit';
import ButtonLanguage from 'components/ui/Buttons/ButtonLanguage';

import styles from './AuthButtons.module.css';

const AuthButtons = () => {
  const setModalType = useZustandModalKitStore(
    zustandModalKitSelector.setModalInfoAction
  );

  const setModalInfo =
    (type: (typeof EModalTypes)[keyof typeof EModalTypes]) =>
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setModalType(type, {
        title:
          type === EModalTypes.SignUp ? 'registrations.title' : 'header.login',
      });
    };

  return (
    <div className={cln(styles.wrapperAuthButtons, styles.row)}>
      <ButtonLanguage />

      <div className={cln(styles.marginLeft, styles.row)}>
        <div
          className={styles.btnText}
          onClick={setModalInfo(EModalTypes.SignIn)}
        >
          <Text idT="header.login" />
        </div>

        <div
          className={cln(styles.marginLeft, styles.btnText)}
          onClick={setModalInfo(EModalTypes.SignUp)}
        >
          <Text idT="header.join" />
        </div>
      </div>
    </div>
  );
};

export default AuthButtons;
